export default __webpack_public_path__ + "static/media/panel1.0355f372.jpg";